{
  "floor/carpets/istockphoto-670381404-612x612.jpg": "/hp/normal/nrm_mat_istockphoto-670381404-612x612.jpg",
  "floor/carpets/istockphoto-628015078-612x612.jpg": "/hp/normal/nrm_mat_istockphoto-628015078-612x612.jpg",
  "floor/carpets/13150589-seamless-artificial-grass-field-texture.jpg": "/hp/normal/nrm_mat_13150589-seamless-artificial-grass-field-texture.jpg",
  "floor/carpets/8.jpg": "/hp/normal/nrm_mat_8.jpg",
  "wall/wood/phytowall03.jpg": "/hp/normal/nrm_mat_phytowall03.jpg",
  "wall/wood/phytowall04.jpg": "/hp/normal/nrm_mat_phytowall04.jpg",
  "wall/wood/wood01.jpg": "/hp/normal/nrm_mat_wood01.jpg",
  "wall/wood/wood03.jpg": "/hp/normal/nrm_mat_wood03.jpg",
  "wall/wood/wood04.jpg": "/hp/normal/nrm_mat_wood04.jpg",
  "wall/wood/wood06.jpg": "/hp/normal/nrm_mat_wood06.jpg",
  "wall/bricks/tiles_fiber_series.jpg": "/hp/normal/nrm_mat_tiles_fiber_series.jpg",
  "wall/finishes/general finishes/14_RILIEVO_GRESS_TOUCH_2317.jpg": "/hp/normal/nrm_mat_14_RILIEVO_GRESS_TOUCH_2317.jpg",
  "wall/finishes/general finishes/53_PATINA_ORO_SU_MARM_2276.jpg": "/hp/normal/nrm_mat_53_PATINA_ORO_SU_MARM_2276.jpg",
  "wall/finishes/general finishes/A318-MAPUTO_diffuse.jpg": "/hp/normal/nrm_mat_A318-MAPUTO_diffuse.jpg",
  "wall/finishes/general finishes/waltx02b.jpg": "/hp/normal/nrm_mat_waltx02b.jpg",
  "wall/finishes/general finishes/waltx04c.jpg": "/hp/normal/nrm_mat_waltx04c.jpg",
  "wall/finishes/general finishes/TCom_Concrete_Damaged_4K_albedo.jpg": "/hp/normal/nrm_mat_TCom_Concrete_Damaged_4K_albedo.jpg",
  "wall/finishes/general finishes/TCom_PatternedConcrete2_New_4K_albedo.jpg": "/hp/normal/nrm_mat_TCom_PatternedConcrete2_New_4K_albedo.jpg",
  "furniture/wood/wood-black.jpg": "/hp/normal/nrm_mat_wood-black.jpg",
  "furniture/wood/wood-beech-effect.jpg": "/hp/normal/nrm_mat_wood-beech-effect.jpg",
  "furniture/wood/woood4.jpg": "/hp/normal/nrm_mat_woood4.jpg"
}
